<template>
    <div
        class="list display--flex"
        :class="{ 'list--fullscreen': !data.hidePagination }"
    >
        <transition-group name="fade-card" tag="div" class="list__content display--grid">
            <template v-if="resetAnimation">
                <base-card
                    v-for="( row, index ) in data.list"
                    :key="row.id"
                    :style="{ '--index': index }"
                >
                    <template #card__title >
                        <list-header
                            :data="{
                                id: row.id,
                                showId: data.showId,
                                header: data.destak,
                                row,
                                ...( data.model && { model: data.model }),
                                ...( data.auditState && { auditState: data.auditState })
                            }"
                        />
                    </template>
                    <template #card__body >
                        <div class="list__body display--grid">
                            <list-group
                                v-for="header in data.headers"
                                :class="`list__body__group__${header.value}`"
                                :data="{
                                    header,
                                    row
                                }"
                                :key="header.value"
                            />
                        </div>
                    </template>
                </base-card>
            </template>
        </transition-group>
        <base-pagination
            v-if="showPagination && !data.hidePagination"
            class="list__pagination"
            :pagination="data.pagination"
        />
    </div>
</template>

<script>
// package
import { ref, computed } from '@vue/composition-api';

export default {
    components: {
        BaseCard: () => import( /* webpackChunkName: 'BaseCard' */ '@/components/bundles/cards/BaseCard' ),
        ListHeader: () => import( /* webpackChunkName: 'ListHeader' */ '@/components/bundles/layout/lists/childrens/ListHeader' ),
        ListGroup: () => import( /* webpackChunkName: 'ListGroup' */ '@/components/bundles/layout/lists/childrens/ListGroup' ),
        BasePagination: () => import( /* webpackChunkName: 'Pagination' */ '@/components/bundles/layout/lists/childrens/Pagination' )
    },
    props: {
        data: Object
    },
    setup ( props ) {
        const resetAnimation = ref( false );

        setTimeout( () => {
            resetAnimation.value = true;
        }, 200 );

        const showPagination = computed(
            () => props.data.hasLoading || ( !props.data.hasLoading && ( props.data.list && props.data.list.length ) )
        );

        return { resetAnimation, showPagination };
    }
};
</script>

<style lang="scss">
    // exemplo 2 -  :style="`transition-delay: .${index + 3}s`"
    // alinhar paginação em baixo
    // list - flex, flex-direction: column, min-height: calc( 100vh - xxxx);
    // list__content - flex-grow: 1
    .list {
        flex-direction: column;
        &--fullscreen {
            min-height: calc( 100vh - 250px );
        }
        &__content {
            grid-template-columns: repeat( 3, 1fr );
            @include responsive( max-width, 1380px ) {
                & {
                    grid-template-columns: repeat( 2, 1fr );
                }
            }
        }
        &__header {
            justify-content: space-between;
            gap: 5px;
            &__id {
                margin-right: 10px;
                @include typography-specs( 20px, 33px, 400 );
                color: $color-green;
            }
            &__destak {
                @include typography-specs( 20px, 33px );
                font-weight: 400;
            }
            &__actions {
                &__info {
                    @include dimensions( 24px, 24px );
                    &:focus {
                        &::before {
                            border: 2px dashed $color-green;
                            @include rounded-corner( 50% );
                        }
                    }
                    &__image {
                        @include dimensions( 100%, 100% );
                    }
                }
            }
        }
        &__body {
            grid-template-columns: repeat( 3, 1fr );
            row-gap: 40px;
            &__group {
                &__header {
                    color: $color-dark;
                    font-weight: 500;
                    margin-bottom: 5px;
                }
                &__email,
                &__progress {
                    grid-column: 1 / 3;
                }
            }
        }
        &__pagination {
            margin-top: 50px;
        }
    }
</style>